import { Play } from 'lucide-react';

export interface NutNgheThuProps {
  title: string;
  previewUrl: string | null;
}

/**
 * Nút nghe thử ở đầu mỗi dòng bảng (ảnh thiết kế: ô vuông bo góc, nền tím).
 * Dữ liệu mẫu chưa có file nghe thử nên nút ở trạng thái tắt, vẫn giữ
 * `aria-label` để trình đọc màn hình hiểu được.
 */
export function NutNgheThu({ title, previewUrl }: NutNgheThuProps) {
  const co = Boolean(previewUrl);

  return (
    <a
      href={previewUrl ?? undefined}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Nghe thử ${title}`}
      title={co ? `Nghe thử ${title}` : 'Chưa có bản nghe thử'}
      aria-disabled={!co}
      className={`inline-flex size-11 shrink-0 items-center justify-center rounded-[10px] ${
        co
          ? 'bg-nhan text-white hover:bg-nhan-dam'
          : 'pointer-events-none bg-neutral-nen text-chu-mo'
      }`}
    >
      <Play size={18} aria-hidden="true" />
    </a>
  );
}
